import React, { useCallback } from 'react'
import { Drawer, Skeleton, Stack, IconButton, Tooltip } from '@mui/material'
import { Row, LevelTag, levelLetter, CatTag, OrgTagIcon, AppTagIcon } from './components'
import Text from '@/components/Text'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles'
import { getNotifigationDetails, deleteNotification } from '@/api'
import { useMutation } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { leastText } from '@/constant'
import Button from '@/components/Button'
import MarkDown from '@/components/MarkDown'
import { confirm } from '@/components/Modal'
import { NotificationType } from '@/types'
import { Message } from '@cx/ui'

export interface NotificationContent {
  id: number | string
  open: boolean
  onClose: () => void
  refecth?: () => void
  dataType?: NotificationType
}

const Content: React.FC<NotificationContent> = (props) => {
  const { open, onClose, id, refecth, dataType } = props
  const theme = useTheme()

  const { data: detail, isLoading } = useQuery(
    ['getNotifigationDetails', id],
    () => getNotifigationDetails(parseInt(id as string)),
    {
      onSuccess: () => {
        // @ts-ignore
        refecth()
      },

      enabled: !!id && !isNaN(parseInt(id as string)),
    },
  )

  const deleteMutation = useMutation(deleteNotification, {
    onSuccess: () => {
      Message.success('消息已删除')
      onClose()
    },
  })

  const handleDelete = useCallback(() => {
    confirm({
      onConfirm: () => {
        if (!!id && !isNaN(parseInt(id as string))) deleteMutation.mutate(parseInt(id as string))
      },
      // @ts-ignore
      onClose: null,
      title: '提示',
      content: '确认删除此消息',
      closeAfterClose: true,
    })
  }, [deleteMutation, id])

  return (
    <Drawer
      sx={{ zIndex: theme.zIndex.drawer + 5, position: 'fixed' }}
      PaperProps={{
        sx: {
          boxShadow: '0px 4px 12px 0px rgba(0,0,0,0.2)',
          padding: '32px',
          backgroundColor: '#fff',
          borderLeft: 'none',
          overflow: 'hidden',
          width: '685px',
          flexDirection: 'column',
        },
      }}
      // @ts-ignore
      componentsprops={{
        backdrop: {
          style: { backgroundColor: 'rgba(0,0,0,0.2)', display: 'none' },
        },
      }}
      variant='persistent'
      hideBackdrop={true}
      anchor='right'
      open={open}
    >
      <Row
        sx={{
          marginBottom: '32px',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        {/* <Text weight="bold" size="md" sx={{ width: "100%" }}>
          消息详情
        </Text> */}
        {isLoading ? (
          <Skeleton width={240} height={30} />
        ) : (
          <Text weight='bold' size='md' sx={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            {detail?.simple_text}
            {/*  @ts-ignore */}
            <LevelTag level={detail?.level}>
              {/*   @ts-ignore */}
              {levelLetter[detail?.level]}
            </LevelTag>
          </Text>
        )}
        <IconButton sx={{ borderRadius: '4px' }} onClick={onClose}>
          <CloseIcon sx={{ fontSize: '16px', color: '#666666' }} />
        </IconButton>
      </Row>
      <Stack sx={{ gap: '8px', flex: 1, height: '85%' }}>
        {/* {isLoading ? (
          <Skeleton width={240} height={30} />
        ) : (
          <Text
            weight="bold"
            size="sm"
            sx={{ display: "flex", alignItems: "center", gap: "24px" }}
          >
            {detail?.simple_text}
            <LevelTag level={detail?.level}>
              {levelLetter[detail?.level]}
            </LevelTag>
          </Text>
        )} */}
        {isLoading ? (
          <Skeleton width={100} height={20} />
        ) : (
          <Text
            weight='regular'
            size='xs'
            sx={{
              color: leastText,
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexWrap: 'wrap',
            }}
          >
            {detail?.created_at} <span>|</span>
            {detail?.send_name && dataType === 'app' && (
              <Tooltip followCursor={true} title={'产品应用'}>
                <Text
                  weight='regular'
                  size='xs'
                  sx={{
                    color: leastText,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <AppTagIcon />
                  {detail?.send_name}
                </Text>
              </Tooltip>
            )}
            {detail?.org_name && (
              <Tooltip followCursor={true} title={'空间'}>
                <Text
                  weight='regular'
                  size='xs'
                  sx={{
                    color: leastText,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <OrgTagIcon />
                  {detail?.org_name}
                </Text>
              </Tooltip>
            )}
          </Text>
        )}
        {isLoading ? (
          <Row sx={{ gap: '8px' }}>
            <Skeleton width={62} height={24} />
            <Skeleton width={62} height={24} />
          </Row>
        ) : (
          <Row sx={{ gap: '8px', flexWrap: 'wrap' }}>
            {detail?.tags?.map((item) => (
              <CatTag key={item?.id}>{item.name}</CatTag>
            ))}
          </Row>
        )}
        {isLoading ? (
          <Skeleton variant='text' width={'100%'} height={100} />
        ) : (
          <MarkDown sx={{ flex: 1, marginTop: '24px' }} content={detail?.full_text} />
        )}
      </Stack>
      <Row sx={{ marginTop: 'auto', justifyContent: 'flex-end' }}>
        <Button type='secondary' onClick={handleDelete}>
          删除
        </Button>
      </Row>
    </Drawer>
  )
}

export default Content
